import { React } from "react";
import "./DialogBox.css";
import { FaFilter } from "react-icons/fa";

const DialogBox = ({ setOpenData, excelData }) => {
  let myDataAmount = Number(0);
    let payOutComm = Number(0);
    let adminPayoutComm = Number(0);
  return (
    <div className="modal-overlay-1">
      <div className="modal-1">
        <h3>Bulk Payout</h3>

        <div className="table-main-report-1">
          <table class="table-user-management">
            <thead class="table-user-report">
              <tr>
                <td>
                  <p className="user-table-head-report">Account-Type</p>
                </td>
                <td>
                  <p className="user-table-head-report">Transfer-Mode</p>
                </td>
                <td className="filter-pos">
                  <div className="data-icon">
                    <p className="user-table-head-report">Branch-Name</p>
                  </div>
                </td>

                <td>
                  <p className="user-table-head-report">
                    Beneficiary-Bank-Name
                  </p>
                </td>

                <td>
                  <p className="user-table-head-report">Amount</p>
                </td>

                <td>
                  <p className="user-table-head-report">Beneficiary-Name</p>
                </td>

                <td>
                  <p className="user-table-head-report">
                    Beneficiary-A/C-Number
                  </p>
                </td>
                <td>
                  <p className="user-table-head-report">IFSC-Code</p>
                </td>
                <td>
                  <p className="user-table-head-report">Address</p>
                </td>
                <td>
                  <p className="user-table-head-report">
                    Beneficiary-Mobile-Number
                  </p>
                </td>
                <td>
                  <p className="user-table-head-report">Beneficiary-Email</p>
                </td>
              </tr>
            </thead>

            <tbody>
              {excelData &&
                excelData.length > 0 &&
                excelData.map((item) => {
                  console.log("item::::::", item);
                  myDataAmount = myDataAmount + item.Amount;
                  if (item.Amount >= 500 && item.Amount <= 1000) {
                    payOutComm = payOutComm + 5;
                    adminPayoutComm =
                      adminPayoutComm + ((1.74 * item.Amount) / 100);
                      console.log("adminnnnn" , adminPayoutComm);
                  } else if (item.Amount >= 1001 && item.Amount <= 25000) {
                    adminPayoutComm =
                    adminPayoutComm + ((1.74 * item.Amount) / 100);
                    payOutComm = payOutComm + 10;
                  } else if (item.Amount >= 25001) {
                    adminPayoutComm =
                    adminPayoutComm + ((1.74 * item.Amount) / 100);
                    payOutComm = payOutComm + 15;
                  }
                  return (
                    <tr className="user-table-head-report">
                      <td>
                        <p className="table-user-data-report order-break">
                          {item && item.AccountType}
                        </p>
                      </td>
                     
                      <td>
                        <p className="table-user-data-report">{item && item.TransferMode}</p>
                      </td>

                      <td>
                        <p className="table-user-data-report">{item && item.BranchName}</p>
                      </td>

                      <td>
                        <p className="table-user-data-report status-table">
                          {item && item.BeneficiaryBankName}
                        </p>
                      </td>

                      <td>
                        <p className="table-user-data-report">{item && item.Amount}</p>
                      </td>

                      <td>
                        <p className="table-user-data-report">{item && item.BeneficiaryName}</p>
                      </td>
                      <td>
                        <p className="table-user-data-report">{item && item.BeneficiaryAccountNumber}</p>
                      </td>
                      <td>
                        <p className="table-user-data-report">{item && item.IFSCCode}</p>
                      </td>

                      <td>
                        <p className="table-user-data-report">{item && item.Address}</p>
                      </td>
                      
                      <td>
                        <p className="table-user-data-report">{item && item.BeneficiaryMobileNumber}</p>
                      </td>
                      <td>
                        <p className="table-user-data-report">{item && item.BeneficiaryEmail}</p>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>

        <div className="modal-button-1">
          <p>No Of Payouts : {excelData && excelData.length}</p>
          <p>Total Amount : {(myDataAmount + payOutComm + adminPayoutComm).toFixed(2)}</p>
          <button className="view-btn" onClick={() => {

             setOpenData(false)
             window.location.reload();
             }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DialogBox;
